import Layout from "../components/Layouts";
import Nav from "../components/Navi";
import Footer from "../components/Footers";
import React from "react";
import styles from "../styles/contactus.module.scss";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";
import CountdownBar from "../components/CountdownBar";

export default function Contactus() {
  const { t } = useTranslation("common");
  return (
    <>
      <div className={`${styles.contactus} my-5 py-5`}>
        <div className="container position-relative mt-5">
          <div className={`${styles.contentWrapper}`}>
            <div className="left-side">
              <img src="https://sahayyacrossingprod.blob.core.windows.net/web-assests/hmp/home-page-images/contact-us.jpg" alt="contact-us" />
            </div>
            <div className={`${styles.rightSide}`}>
              <h1 className="">Contact Us</h1>
              <div className={`${styles.contactInfo}`}>
                <p>
                  For enquiries related to Hayya Media Portal, please contact <b className="bold">media@hayya.qa</b>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <CountdownBar /> */}
    </>
  );
}

Contactus.getLayout = function getLayout(page) {
  return (
    <Layout>
      <Nav />
      {page}
      <Footer />
    </Layout>
  );
};

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common"])),
    },
  };
}
